const debugSettings = {
  /** 테스트용 상품 가져오는지 여부.
   * @default: false
   *  **/
  isGetTestProduct: false,
  /** 결제시 IAMPORT의 WebHook을 받을 것인지 */
  isSendLocalNotice: false,

  /** 모바일 디버깅을 위해 임시 ip주소 사용
   * @default: false
   *  **/
  isMobileApiUrl: false,

  /** 로컬 환경에서 테스트 PG MID 사용 여부
   * @default: true (테스트 MID 사용)
   * true: html5_inicis.INIBillTst (테스트)
   * false: html5_inicis.MOI9209600 (실연동)
   *  **/
  isUseTestPg: false,
};

export default class GlobalEnvironments {
  public static PRODUCTION: boolean =
    process.env.REACT_APP_DOMAIN !== "localhost";

  public static getIsGetTestProduct = () => {
    if (GlobalEnvironments.PRODUCTION) {
      return false;
    } else {
      return debugSettings.isGetTestProduct;
    }
  };
  public static getIsSendLocalNotice = () => {
    if (GlobalEnvironments.PRODUCTION) {
      return false;
    } else {
      return debugSettings.isSendLocalNotice;
    }
  };
  /** 쿠키 api_ns 가 있으면 API 경로 접두어로 쓴다(광해 데모: 포털이 심은 `komir` → …/komir/…). 없으면 기존 주소. */
  public static getApiNamespace = (): string => {
    // 콘엑스 빌드(하위 경로 아님)는 데모 쿠키를 무시한다 — 같은 도메인에서 데모를 써 본 브라우저가
    // 콘엑스 화면에서 데모 API 로 새는 것을 막는다(10-26). 데모는 /komir/ 하위 빌드에서만 돈다.
    if (!(process.env.PUBLIC_URL || "").replace(/\/+/g, "")) return "";
    try {
      const m = document.cookie.match(/(?:^|; )api_ns=([^;]*)/);
      const v = m ? decodeURIComponent(m[1]).trim() : "";
      if (/^[a-z0-9_-]{1,32}$/i.test(v)) return v;
    } catch (e) {
      /* 쿠키 접근 불가 */
    }
    // 하위 경로 배포(PUBLIC_URL=/komir)면 경로 자체가 네임스페이스 — 쿠키가 없거나 지워져도 데모 API 로
    try {
      const pub = (process.env.PUBLIC_URL || "").replace(/^\/+|\/+$/g, "");
      if (pub && window.location.pathname.indexOf("/" + pub) === 0) return pub;
    } catch (e) {
      /* 무시 */
    }
    return "";
  };
  public static getApiUrl = () => {
    const base =
      GlobalEnvironments.PRODUCTION || !debugSettings.isMobileApiUrl
        ? process.env.REACT_APP_API_URL
        : "http://192.168.219.145:8000/";
    const ns = GlobalEnvironments.getApiNamespace();
    if (!ns || !base) return base;
    return base.endsWith("/") ? `${base}${ns}/` : `${base}/${ns}/`;
  };
  public static getDomainUrl = () => {
    if (GlobalEnvironments.PRODUCTION || !debugSettings.isMobileApiUrl) {
      return process.env.REACT_APP_DOMAIN;
    } else {
      return "192.168.219.145";
    }
  };
  public static getAppUrl = () => {
    if (GlobalEnvironments.PRODUCTION || !debugSettings.isMobileApiUrl) {
      return process.env.REACT_APP_URL;
    } else {
      return "http://192.168.219.106:3000/";
    }
  };
  public static getPgProvider = () => {
    if (GlobalEnvironments.PRODUCTION) {
      return "tosspayments.im_ddusulxhio";
    } else {
      if (debugSettings.isUseTestPg) {
        return "tosspayments.iamporttest_3";
      } else {
        return "tosspayments.im_ddusulxhio";
      }
    }
  };

  /** 계좌이체/무통장입금용 PG Provider 반환 */
  public static getTransferPgProvider = () => {
    if (GlobalEnvironments.PRODUCTION) {
      return "tosspayments.im_ddusul8bvu";
    } else {
      if (debugSettings.isUseTestPg) {
        return "tosspayments.iamporttest_3";
      } else {
        return "tosspayments.im_ddusul8bvu";
      }
    }
  };

  /** 정기결제(구독)용 PG Provider 반환 */
  public static getSubscriptionPgProvider = () => {
    if (GlobalEnvironments.PRODUCTION) {
      return "tosspayments.bill_im_dd7a7z";
    } else {
      if (debugSettings.isUseTestPg) {
        return "tosspayments.iamporttest_4";
      } else {
        return "tosspayments.bill_im_dd7a7z";
      }
    }
  };
}
